import { EventName } from '@lit/react';
import { BlocksSlider } from 'blocks-nextjs/blocks-web-components/components/slider/slider';
import { BlocksChangeEvent, BlocksSliderChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatSlider = createComponent({
  react: React,
  tagName: 'cat-slider',
  elementClass: BlocksSlider,
  events: {
    onBlSliderChange: 'bl-slider-change' as EventName<BlocksSliderChangeEvent>,
    onBlChange: 'bl-change' as EventName<BlocksChangeEvent>
  }
});
